module.exports = __webpack_public_path__ + "img/radio-active.a8f125c3.svg";